module.exports = __webpack_public_path__ + "static/img/normalvip.d565ac9.png";


//////////////////
// WEBPACK FOOTER
// ./static/svg/normalvip.png
// module id = d5Dr
// module chunks = 16